import { 
    GET_ELOG_LIST_SUCCESS,
    // GET_ELOG_LIST_ERROR,
    GET_ELOG_PDF_URL_SUCCESS,
    // GET_ELOG_PDF_URL_ERROR,
} from '../actions';

const initialState = {
    listData: [],
    selectedElogPdfUrl: null,
    selectedElogId: null,
};

export default function(state = initialState, action) {
    switch(action.type) {
        case GET_ELOG_LIST_SUCCESS:
            return Object.assign({}, state, { listData: action.payload.data.data.results });
        case GET_ELOG_PDF_URL_SUCCESS:
            return Object.assign({}, state, { 
                selectedElogPdfUrl: action.payload.response.data.PDF_URL,
                selectedElogId: action.payload.response.eLoG_ID,
            });
        default:
            return state;
    }
}